import * as React from "react";
import { useState } from "react";

import { api } from "../api";
import { RLink } from "../DesignSystem/RLink";
import { TestIds } from "../testIds";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  async function submitForgotPassword(): Promise<void> {
    const result = await api.post("/api/forgot-password", { email });

    if (!api.isErrorToast(result)) {
      setSubmitted(true);
    }
  }

  return (
    <div className="px-10 pt-10">
      <div className="mx-auto max-w-[400px]">
        <h2 className="mb-4 text-2xl font-semibold text-gray-800 dark:text-gray-100">
          Forgot password
        </h2>
        <div className="rounded-lg border-b-[3px] border-[#e0dcdc] bg-white p-6 shadow-sm dark:border dark:border-gray-700 dark:bg-gray-800">
          {submitted ? (
            <div className="text-center">
              <div className="mb-4 text-green-600">
                <i
                  className="fa fa-check-circle text-4xl"
                  aria-hidden="true"
                ></i>
              </div>
              <p className="mb-4 text-gray-700 dark:text-gray-300">
                If an account exists with that email, you'll receive a password
                reset link shortly.
              </p>
              <RLink
                className="text-blue-600 hover:underline dark:text-blue-400"
                to="/login"
              >
                Back to login
              </RLink>
            </div>
          ) : (
            <>
              <p className="mb-4 text-sm text-gray-600 dark:text-gray-400">
                Enter your email address and we'll send you a link to reset your
                password.
              </p>

              <div className="mb-6">
                <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Email
                </label>
                <div className="relative">
                  <i
                    className="fa fa-envelope absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                    aria-hidden="true"
                  ></i>
                  <input
                    onChange={(e) => setEmail(e.currentTarget.value)}
                    onKeyDown={(e) =>
                      e.key === "Enter" && submitForgotPassword()
                    }
                    type="email"
                    name="email"
                    data-testid={TestIds.ForgotPasswordEmailInput}
                    className="w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-3 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:placeholder-gray-400"
                    placeholder="Enter your email"
                  />
                </div>
              </div>

              <button
                className="w-full rounded-md bg-[#33cb55] px-4 py-2 text-lg font-medium text-white shadow transition hover:brightness-105"
                data-testid={TestIds.ForgotPasswordSubmit}
                onClick={() => submitForgotPassword()}
              >
                Send reset link
              </button>

              <div className="mt-4 text-center text-sm text-gray-600 dark:text-gray-400">
                Back to{" "}
                <RLink
                  className="text-blue-600 hover:underline dark:text-blue-400"
                  to="/login"
                >
                  Log in
                </RLink>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
